// extracted by mini-css-extract-plugin
export default {"header":"ViewActTeam_header__0RJKW","tabsWrapper":"ViewActTeam_tabsWrapper__uVMZr","assignUserButton":"ViewActTeam_assignUserButton__M--Qc"};